export enum MSG_IDS {
  unknownTariff = "unknownTariff",
  missingAGB = "missingAGB",
  missingPaymentMethod = "missingPaymentMethod",
  missingBankDetails = "missingBankDetails",
  missingNewContractStartDate = "missingNewContractStartDate",
  errorUpdatingLead = "errorUpdatingLead",
  unknownEnergyProvider = "unknownEnergyProvider",
  badRequest = "badRequest",
  no_prices_available = "no_prices_available",
  funnel_order_400 = "funnel_order_400",
  smart_charging_transfer_error = "smart_charging_transfer_error",
  smart_charging_terms_accept_error = "smart_charging_terms_accept_error",
  temporary_problem = "temporary_problem",
  smart_charging_onboarding_transfer_error = "smart_charging_onboarding_transfer_error",
  smart_charging_onboarding_waiting_for_connection = "smart_charging_onboarding_waiting_for_connection",
  smart_charging_onboarding_waiting_for_boot_notification = "smart_charging_onboarding_waiting_for_boot_notification",
  smart_charging_onboarding_missing_data = "smart_charging_onboarding_missing_data",
  smart_charging_onboarding_duplicate_charge_point_id = "smart_charging_onboarding_duplicate_charge_point_id",
}
